import logoCreek from "../common/assets/faviconCreek.png";
import logoNuevamente from "../common/assets/faviconNuevamente.png";
import logoHangover from "../common/assets/faviconHangover.png";
import logoLeparc from "../common/assets/faviconLeparc.png";
//import logoLeparc from "../../common/assets/logoLeparc.png";


let favicon = null;
const tenantId = process.env.REACT_APP_PRODUCT_ID;


if (tenantId == "creek") {
    favicon = logoCreek;
}else if (tenantId == "nuevamente") {
    favicon = logoNuevamente;
}else if (tenantId == "leparc") {
    favicon = logoLeparc;
}else if (tenantId == "hangover") {
    favicon = logoHangover;
}


export default favicon;


// WEBPACK FOOTER //
// ./src/components/FaviconSelector.js